query lookupTravelAgencySearch($lookupName: String!) {
  lookupTravelAgencySearch(lookupName: $lookupName,orderBy:_FULL_NAME_ASC) {
    nodes {
      id
      _fullName
      _isApproved
      _isAliasOriginalNameViewable
      _isAliasInvoked
      _isUpdatable
      supplierAddressesBySupplierId(orderBy: IS_PRIMARY_DESC, first: 1) {
        nodes {
          isPrimary
          addressLine1
          addressLine2
          cityName
          postalCode
          stateRegion {
            stateRegion
            country {
              country
            }
            stateRegionDescription
          }
          telephoneNumber
          emailAddress
        }
      }
      vendorNumber
      vendorServiceRate
    }
  }
}
